import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './COMEQ_Cap_Table.css';

const COMEQ_Cap_Table = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"COMEQ_CAP_TABLE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	COMEQ_CAP_TABLE:-1
  });


  const [COMEQ_CAP_TABLE, setCOMEQ_CAP_TABLE] = React.useState(null);
  const [COMEQ_CAP_TABLE_D, setCOMEQ_CAP_TABLE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Common Equity Cap Table');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCOMEQ_CAP_TABLE(clientInfo,"OpenNew");

		navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCOMEQ_CAP_TABLE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCOMEQ_CAP_TABLE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCOMEQ_CAP_TABLE(clientInfo,"OpenNew");
		}
		navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
		if(Temp_Data2.status!="New"){
			handleDeleteCOMEQ_CAP_TABLE(Temp_Data2);
			navigate('/COMEQ_Cap_Table#New',{replace:true});
		} 
		else 
			navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/COMEQ_Cap_Table',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!COMEQ_CAP_TABLE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_${i}_SECTION`;
	  const headerId = `#COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [COMEQ_CAP_TABLE]) ;


  
  
  var Ids = [];
  for(var Ele in COMEQ_CAP_TABLE){
	  for(var Sec in COMEQ_CAP_TABLE[Ele]){
		if(Sec == "id")
			Ids.push(COMEQ_CAP_TABLE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(COMEQ_CAP_TABLE[Ele]["status"]);
		else if(Array.isArray(COMEQ_CAP_TABLE[Ele][Sec]))
			  for(var Row in COMEQ_CAP_TABLE[Ele][Sec])  // Convert to COMEQ_CAP_TABLE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in COMEQ_CAP_TABLE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["COMEQ_CAP_TABLE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCOMEQ_CAP_TABLE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE`).then((response1) => {
		if(!COMEQ_CAP_TABLE) 
			setCOMEQ_CAP_TABLE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE_D`).then((response2) => {
			setCOMEQ_CAP_TABLE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCOMEQ_CAP_TABLE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCOMEQ_CAP_TABLE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCOMEQ_CAP_TABLE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCOMEQ_CAP_TABLE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCOMEQ_CAP_TABLE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCOMEQ_CAP_TABLE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCOMEQ_CAP_TABLE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_CAP_TABLE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["3"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("3","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["3"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("3","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  

const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["4"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0"]=value;
	Form_Data_onChange("4","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
  }; 
  

    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["5"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("5","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["5"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("5","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["5"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("5","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["5"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("5","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  

const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["5"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4"]=value;
	Form_Data_onChange("5","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
  }; 
  

    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["5"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("5","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  

const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0"]=value;
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
  }; 
  

    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4"]=value;
	//handleAddCOMEQ_CAP_TABLE(Temp_Data,App_Data['COMEQ_CAP_TABLE']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4",value,Temp_Data);
 	//handleLastDataCOMEQ_CAP_TABLE(Temp_Data);
    setCOMEQ_CAP_TABLE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!COMEQ_CAP_TABLE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedCOMEQ_CAP_TABLE =JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
  updatedCOMEQ_CAP_TABLE[Sec] = [...updatedCOMEQ_CAP_TABLE[Sec], newRow];
  setCOMEQ_CAP_TABLE(updatedCOMEQ_CAP_TABLE);
};

const handleDeleteRow = (sec,index) => {
  const updatedCOMEQ_CAP_TABLE = JSON.parse(JSON.stringify(COMEQ_CAP_TABLE));
  updatedCOMEQ_CAP_TABLE[sec].splice(index, 1);
  setCOMEQ_CAP_TABLE(updatedCOMEQ_CAP_TABLE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Common Equity Cap Table`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Common Equity Cap Table ID`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`COMEQ Cap Table ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0" type="text" className="form-control" placeholder="COMEQ Cap Table ID" value={COMEQ_CAP_TABLE["1"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter COMEQ Cap Table ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1" type="text" className="form-control" placeholder="Offering ID" value={COMEQ_CAP_TABLE["1"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2" type="text" className="form-control" placeholder="Investor ID" value={COMEQ_CAP_TABLE["1"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Token Balance`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0" type="text" className="form-control" placeholder="Token Balance" value={COMEQ_CAP_TABLE["2"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Token Balance`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Ownership Percentage Per Token`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1" type="text" className="form-control" placeholder="Ownership Percentage Per Token" value={COMEQ_CAP_TABLE["2"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Ownership Percentage Per Token`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Total Project Ownership Percentage Represented`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2" type="text" className="form-control" placeholder="Total Project Ownership Percentage Represented" value={COMEQ_CAP_TABLE["2"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Total Project Ownership Percentage Represented`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SPV Ownership Percentage Represented`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3" type="text" className="form-control" placeholder="SPV Ownership Percentage Represented" value={COMEQ_CAP_TABLE["2"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SPV Ownership Percentage Represented`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Voting Weight`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Voting Weight`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0" type="text" className="form-control" placeholder="Voting Weight" value={COMEQ_CAP_TABLE["3"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Voting Weight`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Dilution Adjustment Factor`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1" type="text" className="form-control" placeholder="Dilution Adjustment Factor" value={COMEQ_CAP_TABLE["3"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Dilution Adjustment Factor`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Cap Table Status`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Cap Table Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0"  value={COMEQ_CAP_TABLE["4"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0`]} onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_4_0_Change} className="form-control" name="Cap Table Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Reviewed">Reviewed</option>
						  <option value="Approved">Approved</option>
						  <option value="Locked">Locked</option>
						  <option value="Revised">Revised</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Cap Table Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0" type="text" className="form-control" placeholder="Submitted By" value={COMEQ_CAP_TABLE["5"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1" type="text" className="form-control" placeholder="Submitted At" value={COMEQ_CAP_TABLE["5"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={COMEQ_CAP_TABLE["5"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={COMEQ_CAP_TABLE["5"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4"  value={COMEQ_CAP_TABLE["5"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4`]} onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={COMEQ_CAP_TABLE["5"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0"  value={COMEQ_CAP_TABLE["9"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0`]} onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1" type="text" className="form-control" placeholder="Created By" value={COMEQ_CAP_TABLE["9"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2" type="text" className="form-control" placeholder="Created At" value={COMEQ_CAP_TABLE["9"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3" type="text" className="form-control" placeholder="Updated By" value={COMEQ_CAP_TABLE["9"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4" type="text" className="form-control" placeholder="Updated At" value={COMEQ_CAP_TABLE["9"][`COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4`]} 
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_CAP_TABLE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default COMEQ_Cap_Table;  